export default {
    TimeIntervalChosen: {
        datapoint: {
            name: 'UndoSend_TimeIntervalChosen',
            customData: (timeIntervalSeconds: number) => [
                timeIntervalSeconds, // 1. The undo send time interval (amount of time you have to undo a send) chosen in the settings
            ],
        },
    },
};
